module.exports = __webpack_public_path__ + "static/media/document-layout-left.a2bed169.svg";